export default {
  hero: {
    eyebrow: "AllChinaBuy Spreadsheet",
    title: "Trouvez de meilleurs produits avec le Spreadsheet AllChinaBuy",
    subtitle:
      "Explorez des ressources organisées du spreadsheet AllChinaBuy : trouvailles de produits, infos vendeurs, guides QC, conseils de livraison, avis et références d'achat pratiques — tout au même endroit.",
    previewTitle: "Aperçu du Spreadsheet",
    previewCols: {
      category: "Catégorie",
      product: "Produit",
      seller: "Vendeur",
      price: "Prix",
      qc: "QC",
      shipping: "Livraison",
      updated: "Mis à jour",
    },
    previewRows: {
      r1: ["Chaussures", "Baskets basses", "Vérifié", "$$", "Validé", "5–12 j", "Auj."],
      r2: ["Hoodies", "Hoodie oversize", "Populaire", "$$", "Validé", "5–12 j", "Auj."],
      r3: ["T-Shirts", "Tee boxy", "Vérifié", "$", "Validé", "4–10 j", "Auj."],
      r4: ["Sacs", "Tote quotidien", "Populaire", "$$", "En attente", "6–14 j", "Auj."],
    },
  },
  what: {
    title: "Qu'est-ce que le Spreadsheet AllChinaBuy ?",
    body1:
      "Le Spreadsheet AllChinaBuy est un moyen pratique d'organiser et de découvrir des ressources produits, catégories, infos vendeurs et références d'achat utiles.",
    body2:
      "Plutôt que de fouiller des pages éparpillées, utilisez nos guides structurés et ressources de spreadsheet pour comparer les produits, comprendre les infos QC, étudier les options de livraison et prendre des décisions plus éclairées.",
  },
  categories: {
    title: "Catégories populaires du Spreadsheet AllChinaBuy",
    subtitle:
      "Parcourez des catégories de produits organisées et continuez vers les pages correspondantes de notre site principal.",
    select: "Aller à une catégorie",
    viewAll: "Voir toutes les catégories",
  },
  before: {
    title: "Tout ce qu'il faut savoir avant d'acheter",
    cards: {
      review: {
        title: "Avis AllChinaBuy",
        text: "Comprenez la plateforme, son fonctionnement, ses avantages et ses limites éventuelles.",
      },
      shipping: {
        title: "Coût de livraison AllChinaBuy",
        text: "Découvrez ce qui influence les frais de port, les méthodes de livraison et le coût total.",
      },
      warehouse: {
        title: "Entrepôt AllChinaBuy",
        text: "Comprenez le stockage, l'inspection QC et les aspects liés à l'entrepôt.",
      },
      coupon: {
        title: "Coupon AllChinaBuy",
        text: "Trouvez des infos sur les coupons, promotions et le fonctionnement des remises.",
      },
      discount: {
        title: "Code promo AllChinaBuy",
        text: "Découvrez comment les codes promo fonctionnent et quoi vérifier avant de les utiliser.",
      },
      legit: {
        title: "AllChinaBuy fiable",
        text: "Comprenez les points essentiels de légitimité, sécurité et vérification.",
      },
    },
  },
  compare: {
    title: "Comparez avant d'acheter",
    subtitle: "Utilisez ces points de comparaison pour décider plus sereinement.",
    headers: {
      topic: "Sujet",
      check: "À vérifier",
      considerations: "Points importants",
      bestFor: "Idéal pour",
    },
    rows: {
      products: {
        topic: "Produits",
        check: "Photos, mesures, matières",
        considerations: "Comparez plusieurs annonces avant de choisir",
        bestFor: "Trouver le bon article",
      },
      sellers: {
        topic: "Vendeurs",
        check: "Avis, historique, réactivité",
        considerations: "Privilégiez les vendeurs aux antécédents clairs",
        bestFor: "Réduire le risque",
      },
      shipping: {
        topic: "Livraison",
        check: "Méthode, poids, destination",
        considerations: "Les articles lourds coûtent souvent plus cher",
        bestFor: "Planifier son budget",
      },
      qc: {
        topic: "QC",
        check: "Photos d'inspection, mesures",
        considerations: "Demandez le QC avant expédition si possible",
        bestFor: "Détecter les problèmes tôt",
      },
      categories: {
        topic: "Catégories",
        check: "Type de produit pertinent",
        considerations: "Partez de la bonne catégorie",
        bestFor: "Naviguer plus vite",
      },
      buying: {
        topic: "Méthodes d'achat",
        check: "Processus de commande, paiement",
        considerations: "Comprenez le processus avant de commander",
        bestFor: "Un paiement plus fluide",
      },
    },
  },
  how: {
    title: "Comment fonctionne le Spreadsheet AllChinaBuy",
    steps: {
      s1: { title: "Choisissez une catégorie", text: "Partez de la catégorie qui correspond à votre besoin." },
      s2: { title: "Explorez les ressources", text: "Passez en revue les références produits et vendeurs organisées." },
      s3: { title: "Comparez produits et vendeurs", text: "Pesez les options côte à côte avant de décider." },
      s4: { title: "Vérifiez QC et points d'achat", text: "Comprenez ce qu'il faut vérifier avant de commander." },
      s5: { title: "Étudiez livraison et entrepôt", text: "Estimez les coûts, délais et le stockage." },
      s6: { title: "Continuez vers le site principal", text: "Rendez-vous sur notre site principal quand vous êtes prêt." },
    },
  },
  qc: {
    title: "Guide QC & Sécurité AllChinaBuy",
    body: "Avant de commander, gardez ces points pratiques à l'esprit.",
    items: {
      photos: { title: "Photos QC", text: "Examinez les photos d'inspection et demandez des clichés supplémentaires." },
      inspection: { title: "Inspection produit", text: "Vérifiez les mesures, étiquettes et l'état général." },
      seller: { title: "Vérification vendeur", text: "Regardez l'historique et les avis du vendeur avant d'acheter." },
      descriptions: { title: "Descriptions produit", text: "Lisez attentivement les annonces pour confirmer taille et matière." },
      payment: { title: "Vigilance paiement", text: "Utilisez uniquement le processus de paiement officiel." },
      shipping: { title: "Risques de livraison", text: "Comprenez les délais et les éventuels retards." },
      refund: { title: "Remboursements", text: "Connaissez la politique de remboursement avant de vous engager." },
      personal: { title: "Données personnelles", text: "Protégez vos informations et évitez les contacts non vérifiés." },
      scam: { title: "Signaux d'arnaque", text: "Méfiez-vous des offres trop belles pour être vraies." },
    },
    read: "Lire le guide de sécurité",
  },
  guides: {
    title: "Derniers guides et avis AllChinaBuy",
    subtitle: "Explorez nos guides originaux écrits pour des infos d'achat pratiques et utiles.",
    card1: {
      category: "Guide Spreadsheet",
      title: "Qu'est-ce que le Spreadsheet AllChinaBuy ? Guide complet 2026",
      summary: "Un tour d'horizon complet : fonctionnement, contenu et utilisation du spreadsheet.",
      date: "Mis à jour 2026",
      cta: "Lire le guide",
    },
    card2: {
      category: "QC & Sécurité",
      title: "Checklist QC & Sécurité AllChinaBuy",
      summary: "Les points pratiques à vérifier avant d'acheter, des photos QC aux contrôles vendeur.",
      date: "Mis à jour 2026",
      cta: "En savoir plus",
    },
    card3: {
      category: "Livraison",
      title: "Livraison et coûts AllChinaBuy",
      summary: "Ce qui influence les frais de port, les délais et le stockage en entrepôt.",
      date: "Mis à jour 2026",
      cta: "En savoir plus",
    },
  },
  faq: {
    title: "Questions fréquentes",
    items: {
      q1: {
        q: "Qu'est-ce qu'un Spreadsheet AllChinaBuy ?",
        a: "C'est une ressource organisée qui regroupe trouvailles produits, catégories, vendeurs et références d'achat pour comparer plus facilement avant de commander.",
      },
      q2: {
        q: "Comment fonctionne le spreadsheet ?",
        a: "Vous partez d'une catégorie, explorez les ressources organisées, comparez produits et vendeurs, vérifiez QC et livraison, puis continuez vers le site principal.",
      },
      q3: {
        q: "AllChinaBuy est-il fiable ?",
        a: "AllChinaBuy est une plateforme de type agent d'achat utilisée par de nombreux acheteurs. Faites vos propres vérifications, contrôlez l'historique du vendeur et lisez les conditions avant de commander.",
      },
      q4: {
        q: "AllChinaBuy est-il sûr ?",
        a: "Utilisez le processus de paiement officiel, protégez vos informations personnelles et méfiez-vous des offres trop belles pour être vraies.",
      },
      q5: {
        q: "Combien coûte la livraison AllChinaBuy ?",
        a: "Le coût dépend du poids, des dimensions, de la méthode et de la destination. Les articles lourds ou volumineux coûtent plus cher, et les méthodes rapides sont souvent plus onéreuses.",
      },
      q6: {
        q: "AllChinaBuy propose-t-il des coupons ?",
        a: "Les coupons et promotions varient avec le temps. Consultez le site principal pour les offres actuelles et lisez les conditions avant d'utiliser un code.",
      },
      q7: {
        q: "Qu'est-ce que l'entrepôt AllChinaBuy ?",
        a: "L'entrepôt est l'endroit où les articles peuvent être stockés et inspectés avant expédition. Le stockage et le QC peuvent influencer le coût et les délais.",
      },
      q8: {
        q: "Comment vérifier le QC ?",
        a: "Demandez des photos QC, examinez les mesures, étiquettes et l'état, puis comparez avec la description avant d'approuver l'expédition.",
      },
      q9: {
        q: "Comment comparer les produits ?",
        a: "Utilisez les points de comparaison ci-dessus : vérifiez photos, vendeurs, livraison, QC et catégories côte à côte pour décider plus sereinement.",
      },
    },
  },
  finalCta: {
    title: "Prêt à explorer davantage ?",
    body: "Trouvez des ressources organisées, des guides pratiques et des infos d'achat utiles avant votre prochain achat.",
    button: "Explorer le Spreadsheet",
    secondary: "Visiter le site principal",
  },
};